import React from 'react'
import Utils from '../../util/Utils'
import { loginStore } from '../../state/CommonState';

export default function FinanceDataTable({results , type}) {
  
  let types = {
    TCU: "totalList",
    UD: "upcomingList",
    OD: "overdueList",
    PR: "pendinglist",
    AH: "accountingHealthList",

    }

  function isGljType (r) {
   if (r.DOCUMENT_NO === '1133-GLJ-202311100001'){
    return true
   }
   return false
  }

const isClient = loginStore.isClient();

const columns = [];

if (!isClient) columns.push({ key: 'CUSTOMER_NAME', label: 'Customer'  , width: "200px"});
if (type !== types.PR) columns.push({ key: 'bookingNum', label: 'Booking #' , width: "200px"  });

if (type === types.PR || type === types.AH) {
  columns.push({ key: 'DOCUMENT_NO', label: 'Voucher #' ,  width: "200px" });
} else {
  columns.push({ key: 'DOCUMENT_NO', label: 'Invoice #' ,  width: "200px" });
}

columns.push({
  key: 'DOCUMENT_DATE',
  label: type === types.PR ? 'Receipt Date' : type === types.AH ? 'Voucher Date' : 'Invoice Date',
   width: "200px"
});

if (type !== types.PR && type !== types.AH) columns.push({ key: 'DUE DAYS', label: 'Due Date' , width: "120px" });

if ([types.TCU , types.UD , types.OD ].includes(type)) { 
  columns.push({ key: 'CREDIT_DAY', label: 'Credit Days' ,width: "100px" });
  columns.push({ key: 'CURRENCY_CODE', label: 'Currency' ,width: "100px" });
  columns.push({ key: 'OUTSTANDING_CURRENCY_AMOUNT', label: 'Outstanding Amount' , width: "180px" });
  columns.push({ key: 'OUTSTANDING_LOCAL_AMOUNT', label: 'Outstanding Amount(INR)', width: "200px" });
}

if (type !== types.PR && type !== types.AH ) columns.push({ key: 'customerReferenceNum', label: 'Customer Reference #' ,width: "150px" });

if (type === types.PR) columns.push({ key: 'OUTSTANDING_LOCAL_AMOUNT', label: 'Unmatched Credit(INR)' , width: "180px" });

if ([types.TCU, types.UD, types.OD, types.PR].includes(type)) columns.push({ key: 'HOUSE_NO', label: 'House Number' , width: "180px" });

if ([types.TCU, types.OD].includes(type)) columns.push({ key: 'AGEING', label: 'Ageing' , width: "80px" });
if (type === types.UD) columns.push({ key: 'DOC_AGEING', label: 'Document Ageing' , width: "100px" });
if (type === types.OD) columns.push({ key: 'overduedays', label: 'Overdue Days ' , width: "120px" });

if (type === types.AH) columns.push({ key: 'OUTSTANDING_LOCAL_AMOUNT', label: 'Amount(INR)' , width: "150px" });

if ([types.PR, types.AH].includes(type)) columns.push({ key: 'NARRATION', label: 'Remarks' , width: "100px" });



  return (
    <div>
     {/* <table  style={{ width: "100%", borderCollapse: "collapse" }}>
     <thead style={{ backgroundColor : "#2C358A" , textAlign: "center" , color : "#FFFFFF"}}>
        <th style={{ width: "20em" , color : "#FFFFFF" }}>Customer</th>
        <th style={{ width: "15%" , color : "#FFFFFF" }}>Booking</th>
        <th style={{ width: "15%" , color : "#FFFFFF" }}>Invoice</th>
        <th style={{ width: "10%" , color : "#FFFFFF" }}>Invoice Date</th>
        <th style={{ width: "10% ", color : "#FFFFFF" }}>Due Date</th>
        <th style={{ width: "10%" , color : "#FFFFFF" }}>Credit Days</th>
        <th style={{ width: "10%" , color : "#FFFFFF" }}>Currency</th>
        <th style={{ width: "10%" , color : "#FFFFFF" }}>Outstanding Amount</th>
     </thead>
     </table>
      <div style={{maxHeight : "70vh" , overflowY : 'scroll', overflowX : 'scroll' ,overflowX: 'scroll' ,minWidth : "100%" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
        { results?.[type]?.map((r,i)=>{
            return <tr>
                <td style={{ width: "20em" }}>{r.CUSTOMER_NAME}</td>
                <td style={{ width: "15%" }}>{r.bookingNum}</td>
                <td style={{ width: "15%" }}>{isGljType(r)?  r.NOTE : r.DOCUMENT_NO}</td>
                <td style={{ width: "10%" }}>{r.DOCUMENT_DATE}</td>
                <td style={{ width: "10%" }}>{r['DUE DAYS']}</td>
                <td style={{ width: "10%" }}>{r.CREDIT_DAY}</td>
                <td style={{ width: "10%" }}>{r.CURRENCY_CODE}</td>
                <td style={{ width: "10%" }}>{r.OUTSTANDING_LOCAL_AMOUNT}</td>

            </tr>
        })

        }

        </tbody>
        </table>
      </div> */}

      <div style={{ maxHeight: "70vh", overflowY: "auto", overflowX: "auto", width: "100%" }}>
  <table style={{ minWidth: "1200px", borderCollapse: "collapse", tableLayout: "fixed" , width: "100%" }}> 
    <thead style={{ backgroundColor: "#2C358A", color: "#FFFFFF" , padding: "2% 4%" , height : '30px' }}>
      <tr className='figtree-text' style={{ color: "#FFFFFF"}}>
                 {columns.map(col => (
      <th className='financetableth' style={{ width: col.width }} key={col.key}>{col.label}</th>
    ))}

              {/* <th className='financetableth' style={{ width: "200px" }}>Customer</th>
              <th className='financetableth' style={{ width: "200px" }}>Booking</th>
              <th className='financetableth' style={{ width: "200px" }}>Invoice</th>
              <th className='financetableth' style={{ width: "150px" }}>Invoice Date</th>
              <th className='financetableth' style={{ width: "120px" }}>Due Date</th>
              <th className='financetableth' style={{ width: "80px" }}>Credit Days</th>
              <th className='financetableth' style={{ width: "80px" }}>Currency</th>
              <th className='financetableth' style={{ width: "180px" }}>Outstanding Amount</th>
              <th className='financetableth' style={{ width: "200px" }}>Outstanding Amount(INR)</th>
              <th className='financetableth' style={{ width: "150px" }}>Customer Reference</th>
              <th className='financetableth' style={{ width: "180px" }}>House Number</th>
              <th className='financetableth' style={{ width: "80px" }}>Ageing</th> */}
        {/* Add more <th> as needed */}
      </tr>
    </thead>
    <tbody >
      {results?.[type]?.map((r, i) => (
          <tr key={i}>
      {columns.map(col => {
        const value = col.key === 'AGEING'
          ? Utils.docAgeing(r)
          : col.key === 'DOC_AGEING'
          ? Utils.docAgeing(r)
          : col.key === 'DOCUMENT_DATE' || col.key === 'DUE DAYS'
          ? Utils.getDateString(r[col.key])
          : col.key === 'OUTSTANDING_CURRENCY_AMOUNT' || col.key === 'OUTSTANDING_LOCAL_AMOUNT'
          ? Utils.N2(r[col.key])
          : col.key === 'overduedays'
          ? Math.abs(r[col.key])
          : r[col.key];

        return <td className='financetabletd' key={col.key}>{value}</td>;
      })}
    </tr>
      

      ))}
    </tbody>
  </table>
</div>


    

      
    </div>
  )
}

 
